function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFC107",
  d: "M21.805 10.041H21V10h-9v4h5.651c-.824 2.328-3.04 4-5.651 4-3.313 0-6-2.687-6-6s2.687-6 6-6c1.53 0 2.921.577 3.98 1.52L18.81 4.69C17.023 3.027 14.634 2 12 2 6.478 2 2 6.478 2 12c0 5.523 4.478 10 10 10 5.523 0 10-4.477 10-10 0-.67-.069-1.325-.195-1.959z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3D00",
  d: "M3.153 7.346l3.285 2.409C7.328 7.554 9.48 6 12 6c1.53 0 2.921.577 3.98 1.52L18.81 4.69C17.023 3.027 14.634 2 12 2 8.159 2 4.828 4.168 3.153 7.346z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#4CAF50",
  d: "M12 22c2.583 0 4.93-.988 6.704-2.596l-3.095-2.619c-1.037.79-2.305 1.216-3.609 1.215-2.601 0-4.81-1.659-5.641-3.973L3.098 16.54C4.753 19.777 8.114 22 12 22z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "#1976D2",
  d: "M21.805 10.041H21V10h-9v4h5.651c-.394 1.108-1.104 2.077-2.043 2.785h.002l3.095 2.619C18.485 19.602 22 17 22 12c0-.67-.069-1.325-.195-1.959z"
});

var SvgGoogleColor = function SvgGoogleColor(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGoogleColor, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/google-color.9702931b.svg";
export { ForwardRef as ReactComponent };